export default "__VITE_ASSET__CK99kXnQ__"